import { string, shape, bool, array } from "prop-types";
import { getSanityNextImage } from "@lib/getImages";
import { getLink } from "@lib/getLink";
import { Footer } from "./Footer";
import { LinkableArea } from "./LinkableArea";
import { SMALL, MED, LRG, LIGHT, LEFT } from "./constants";
import blockClass from "./styles/Block.module.css";
import imageClass from "./styles/Image.module.css";
import footerClass from "./styles/Footer.module.css";

export default function ContentBlockImage({ data }) {
  const {
    altText,
    footerOptions: { caption, showFooter, footerOnTop, footerAlign, textColor, ctaTitle, ctaLink },
    spacingOptions: { padding },
  } = data;

  const sizes = { small: "600", medium: "600", large: "800" };
  const formattedCtaLink = ctaLink ? getLink(ctaLink) : {};

  const imageStyles = `
    ${imageClass.picture}
    ${padding === SMALL ? blockClass.paddingSm : ""}
    ${padding === MED ? blockClass.paddingMed : ""}
    ${padding === LRG ? blockClass.paddingLrg : ""}
  `;

  const footerStyles = `
    ${footerClass.container}
    ${textColor === LIGHT ? footerClass.light : ""}
    ${footerOnTop ? footerClass.inner : ""}
    ${footerAlign === LEFT ? footerClass.left : ""}
  `;

  const Image = () => {
    return (
      <figure className={imageClass.container}>
        <picture className={imageStyles}>
          <div className={imageClass.innerContainer}>
            {getSanityNextImage(data, sizes, altText)}
            {showFooter && (
              <Footer
                styles={footerStyles}
                caption={caption}
                ctaTitle={ctaTitle}
                ctaLink={ctaLink}
              />
            )}
          </div>
        </picture>
      </figure>
    );
  };

  if (ctaLink && (ctaLink.handle || ctaLink.link?.href || ctaLink.slug?.current)) {
    return (
      <LinkableArea rawLink={ctaLink} formattedLink={formattedCtaLink}>
        <Image />
      </LinkableArea>
    );
  }

  return <Image />;
}

ContentBlockImage.propTypes = {
  data: shape({
    _key: string,
    _type: string,
    altText: string,
    asset: shape({
      _ref: string,
      _type: string,
    }),
    footerOptions: shape({
      showFooter: bool,
      footerOnTop: bool,
      footerAlign: string,
      textColor: string,
      caption: string,
      ctaTitle: string,
      ctaLink: shape({
        refTitle: string,
        type: string,
        handle: string,
        link: shape({
          _type: string,
          blank: bool,
          href: string,
        }),
        slug: shape({
          _type: string,
          current: string,
        }),
        productGroup: array,
      }),
    }),
    spacingOptions: shape({
      padding: string,
    }),
  }),
};
